import { useState, useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  addClient,
  getClients,
  getClient,
  editClient,
  deleteClient,
  getAllClients,
} from "../../store/actions/client_action";
import _debounce from "lodash/debounce";
import { useSelectAllGroup } from "./UseGroup";
// import { useSelectAllIndustry } from "./UseIndustry";

// Get All Data
export const useAllClients = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.client);
  const [pageNumber, setPageNumber] = useState(1);
  const [deleteEntry, setDeleteEntry] = useState(null);

  useEffect(() => {
    if (deleteEntry) {
      dispatch(deleteClient(deleteEntry));
    }
    allQuery();
  }, [deleteEntry, pageNumber, window.location.search]);
  const allQuery = useCallback(
    _debounce(() => {
      dispatch(
        getClients({
          pageNumber,
        })
      );
    }, 1000),
    []
  );

  useEffect(() => {
    setPageNumber(1);
  }, [window.location.search]);

  const deleteBtnClicked = async (id) => {
    setDeleteEntry(id);
  };

  return [data, setPageNumber, deleteBtnClicked];
};

// Get Single Data
export const useSingleClient = (id) => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.client);
  useEffect(() => {
    dispatch(getClient(id));
  }, [id]);
  return [data];
};
// Add Data
export const useCreateClient = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.client);
  const addData = async (data) => {
    await dispatch(addClient(data));
  };
  return [data, addData];
};
export const useUpdateClient = () => {
  const dispatch = useDispatch();
  // const data = useSelector((state) => state.client);
  const updateData = async (id, data) => {
    await dispatch(editClient(id, data));
  };
  return [updateData];
};

export const useSelectAllClient = () => {
  const dispatch = useDispatch();
  const [term, setTerm] = useState("");
  const [value, setValue] = useState("");
  const data = useSelector((state) => state.client);
  useEffect(() => {
    dispatch(getAllClients({ term, value }));
  }, [term, value]);
  return [data, setTerm, setValue];
};

export const useGetDropdownOptions = () => {
  const [group] = useSelectAllGroup();

  const [dropdownOptions, setDropdownOptions] = useState({});
  useEffect(() => {
    if (group && group.all_groups) {
      const newData = group.all_groups.map((item) => {
        return { label: item.name, value: item._id };
      });
      setDropdownOptions({ ...dropdownOptions, groups: newData });
    }
  }, [group]);
  const loadOptions = async (inputValue, callback, field) => {
    // if (field == "parent_category") {
    //   await setCategorySearchField("name");
    //   await setCategorySearchValue(inputValue);
    //   callback(dropdownOptions.parent_category);
    // }
  };

  return [dropdownOptions, loadOptions];
};
